// NavigateFunction is used to type the navigate parameter passed into handleTileClick in /dashboard.handlers.ts.
import { NavigateFunction } from "react-router-dom";

export const handleTileClick = (
  path: string,
  requiresLoa: boolean,
  openModal: (destination: string) => void,
  navigate: NavigateFunction,
): void => {
  if (requiresLoa) {
    openModal(path);
  } else {
    // Navigate directly for tiles that don't require LOA.
    navigate(path);
  }
};
